<template>
  <div id="submitted">
    <form ref="form">
      <ol class="questions">
        <li>
          <fieldset>
            <legend>
              <p><i class="fa fa-check-circle"></i> Thank you for your refund request.</p>
              <h2 id="submittedTitle">What happens next?</h2>
              <p>
                We have sent you an email and you will hear from us within 10
                business days regarding the refund request.
              </p>
            </legend>

          </fieldset>
        </li>
      </ol>
    </form>
  </div>
</template>

<script>
export default {
  name: "Submitted",
  props: {

  },
  methods: {},
};
</script>

<style scoped lang="scss">
#submitted {
  min-height: 20em;
}
#return {
  margin-top: 3em;
  color: white !important;
  text-decoration: none !important;
}
</style>